import { render } from 'preact';
import { App } from './app.tsx';

render(<App />, document.getElementById('app')!);

// Offline: the shell's service worker (production builds; it precaches this build's files).
if (import.meta.env.PROD && 'serviceWorker' in navigator) navigator.serviceWorker.register('/sw.js').catch(() => {});
